<template>
  <div class="zone-id-uid-main">
    <div :class="bindZoneIdUidClass">
      <div class="lt">
        <input
          id="uid-input"
          ref="uid-input"
          v-model="uidValue"
          @input="handleInput"
          :style="bindInputStyle"
          :placeholder="uidPlaceholder"
          @blur="handleBlur"
          @keyup.enter="handleBlur"
          @focus="handleFocus"
        />

        <div class="check-info">
          <img
            class="error"
            v-show="validator.isError"
            :src="require('@/assets/images/detail/uid_error.png')"
            alt="error"
            @click.stop="handleIcon('uid')"
            @mousedown="handleMousedown"
          />
          <img
            class="success"
            v-show="validator.isSuccess"
            :src="successIcon"
            alt="success"
          />
          <van-loading
            v-show="validator.isLoading"
            type="spinner"
            class="loading-icon"
          />
        </div>
      </div>
      <div class="rt">
        <input
          ref="zid-input"
          v-model="zoneId"
          @input="handleInput"
          maxlength="6"
          :style="bindInputStyle"
          @blur="handleBlur"
          @keyup.enter="handleBlur"
          :placeholder="zoneIdPlaceholder"
        />

        <div class="check-info">
          <img
            class="error"
            v-show="validator.isZidError"
            :src="require('@/assets/images/detail/uid_error.png')"
            alt="error"
            @click.stop="handleIcon('zid')"
            @mousedown="handleMousedown"
          />
          <img
            class="success"
            v-show="validator.isSuccess"
            :src="successIcon"
            alt="success"
          />
          <van-loading
            v-show="validator.isLoading"
            type="spinner"
            class="loading-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import { storage } from '@/utils/storage'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { injectionCheckUid } from '@page_detail/utils/validators'
  import { hexToRgba } from '@/utils/hexToRgba'
  import {
    inputUidFail,
    inputUidSuccess,
    inputUidManual,
    autoInputUid,
  } from '@page_detail/firebase'

  let timer = null
  export default {
    name: 'zone-id-uid-comp',
    mixins: [styleConfiguration],
    data() {
      return {
        initLoad: true,
        isEventSelect: false,
        zoneId: '', // zone
        uidValue: '', //UID
        cacheSkuState: [], //缓存选中每个SKU的状态
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误uid
          isZidError: false, // 验证错误zid
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
        },
        errorCode: 0,
      }
    },
    components: {},
    mounted() {},
    destroyed() {
      clearTimeout(timer)
    },
    computed: {
      ...mapState(['gameName', 'isDesktop', 'isMobile', 'region', 'isIAP']),
      ...mapState('detail', [
        'serverList',
        'isUidFocus',
        'selectSkuItem',
        'selectChannelItem',
      ]),
      ...mapGetters('detail', ['cacheUidKey', 'cacheZidKey']),
      bindZoneIdUidClass() {
        const defaultClass = ['zone-id-uid-content']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        device.push(`${defaultClass[0]}-config`)
        return defaultClass.concat(device)
      },

      bindInputStyle() {
        const bgColor = this.skuBackColor.backgroundColor
        const borderColor = this.skuBackColor.borderColor
        const textColor = this.mFontColor.color
        const styles = {}

        if (bgColor) {
          styles.backgroundColor = bgColor
          styles['--uidInputBg'] = bgColor
        }
        if (borderColor) {
          styles.borderColor = borderColor
          styles['--uidInputBorderColor'] = borderColor
        }
        if (textColor) {
          styles.color = textColor
          styles['--uidInputTextColor'] = textColor
          styles['--uidInputPlaceholderColor'] = hexToRgba(textColor)
        }

        return styles
      },
      uidPlaceholder() {
        const key = `${this.gameName}.uid_placeholder`
        return this.$te(key)
          ? this.$t(key)
          : this.$t('publicDetails.uid_placeholder', {
              uid: 'User ID',
            })
      },
      zoneIdPlaceholder() {
        const key = `${this.gameName}.zoneid_placeholder`
        const zidMsg = this.$te(key)
          ? this.$t(key)
          : this.$t('publicDetails.zoneid_placeholder')

        if (this.isMobile) {
          return `(    ${zidMsg}    )`
        }
        return `${zidMsg}`
      },
      successIcon() {
        return require('@/assets/images/detail/common/success.png')
      },
    },
    watch: {
      selectSkuItem: {
        handler(newVal) {
          if (isEmpty(newVal)) return
          if (this.initLoad) {
            this.getCacheUid()
            this.initLoad = false
          } else {
            const res = this.verSelectSkuItem()
            if (res) {
              this.isEventSelect = true
              this.verifyUid()
            }
          }
        },
        deep: true,
        immediate: true,
      },
      isUidFocus(newVal) {
        if (newVal === -1) return
        this.getFocus()
      },
    },
    methods: {
      ...mapMutations([
        'detail/setNickName',
        'detail/setUserId',
        'detail/setServerId',
        'detail/setAccountId',
        'detail/setCheckServerItem',
        'detail/setUidValidator',
      ]),

      handleFocus() {
        inputUidManual(this.gameName)
      },

      // 点击SKU的时候 进行 校验交互
      verSelectSkuItem() {
        if (this.uidValue.trim() === '') {
          this.$refs['uid-input'] && this.$refs['uid-input'].focus()
          return false
        } else if (this.zoneId.trim() === '') {
          this.$refs['zid-input'] && this.$refs['zid-input'].focus()
          return false
        }
        return true
      },

      // todo 每次切换SKU的时候、进行缓存处理较少接口请求、保证性能
      // [{key:xxx,data:xxxx}]
      setCacheSkuState({ key = '', data = null }) {
        const _cacheSkuState = [...this.cacheSkuState]
        if (key === '') {
          throw Error('传递key不能为空')
        }

        if (data === null) return
        const _key = _cacheSkuState.findIndex((item) => item.key === key)
        const _data = {
          key,
          data,
        }
        if (_key !== -1) {
          _cacheSkuState[_key] = _data
        } else {
          _cacheSkuState.push(_data)
        }
        this.cacheSkuState = _cacheSkuState
      },

      // TODO 失焦联动SKU校验缓存数据
      handleCacheSkuState(parames) {
        const _cacheSkuState = [...this.cacheSkuState]
        const isItems = _cacheSkuState.find(
          (item) => item.key === parames.skuId
        )

        let res1 = true

        if (isItems) {
          let nickNameList = isItems.data.nick || ''
          let suid = isItems.data.uid || ''
          let szoneId = isItems.data.zoneId || ''
          let res = isItems.data.res || false
          if (parames.uid !== suid || parames.cpServerId !== szoneId) {
            return false
          }

          if (res) {
            this['detail/setNickName'](nickNameList || '')
            this['detail/setUserId'](parames.uid || '')
            this['detail/setServerId'](parames.cpServerId || '')

            this.handleCheck({ isSuccess: true })
            this.handleCache('set', {
              uid: parames.uid,
              zid: parames.cpServerId,
            })
          } else {
            this.errorCode = isItems.data.errorCode
            this.handleCheck({ isError: true, isZidError: true })
            this['detail/setNickName']('')
            this['detail/setUserId']('')
            this['detail/setServerId']('')
          }
        }
        return !!isItems && res1
      },

      getFocus() {
        const isFocusUserid = this.errorCode.toString() === '1003'
        if (isFocusUserid) {
          this.$refs['uid-input'] && this.$refs['uid-input'].focus()
        } else {
          this.$refs['zid-input'] && this.$refs['zid-input'].focus()
        }
      },

      getCacheUid() {
        const { uid, zid } = this.handleCache('get')
        if (!(uid && zid)) return

        this.uidValue = uid
        this.zoneId = zid
        this.verifyUid()

        autoInputUid(this.gameName)
      },

      handleCache(type = 'get', { uid = '', zid = '' } = {}) {
        if (type === 'get') {
          const uid = storage.get(this.cacheUidKey) || null
          const zid = storage.get(this.cacheZidKey) || null
          return {
            uid,
            zid,
          }
        }
        if (type === 'set') {
          storage.set(this.cacheUidKey, uid)
          storage.set(this.cacheZidKey, zid)
        }
      },
      handleCheck({
        isInInput = false,
        isError = false,
        isZidError = false,
        isSuccess = false,
        isLoading = false,
      } = {}) {
        this.validator = {
          isInInput,
          isError,
          isZidError,
          isSuccess,
          isLoading,
        }
        this['detail/setUidValidator'](this.validator)
      },

      // https://segmentfault.com/q/1010000004950602
      handleMousedown(event) {
        event.preventDefault()
      },

      handleIcon(type) {
        if (type == 'uid') {
          this.uidValue = ''
          this.$nextTick(() => {
            this.$refs['uid-input'] && this.$refs['uid-input'].focus()
            this.handleCheck({
              isZidError: true,
            })
          })
          return
        }

        if (type == 'zid') {
          this.zoneId = ''
          this.$nextTick(() => {
            this.$refs['zid-input'] && this.$refs['zid-input'].focus()
            this.handleCheck({
              isError: true,
            })
          })
        }
      },

      // 获取公共参数
      publicParames() {
        const { skuId = '' } = this.selectSkuItem
        const result = {
          uid: this.uidValue,
          gameName: this.gameName,
          cpServerId: this.zoneId,
          skuId,
        }
        return result
      },
      handleBlur() {
        this.verifyUid()
      },

      async verifyUid() {
        if (this.uidValue.trim() === '' || this.zoneId.trim() === '') return

        this.handleCheck({ isLoading: true })
        const parames = this.publicParames()

        try {
          const result = await injectionCheckUid(parames)

          if (result && result.res) {
            let nickNameList = result.nick || ''
            this['detail/setNickName'](nickNameList || '')
            this['detail/setUserId'](parames.uid || '')
            this['detail/setCheckServerItem']({
              cpServerId: parames.cpServerId || '',
            })
            this.handleCheck({ isSuccess: true })
            this.handleCache('set', {
              uid: parames.uid,
              zid: parames.cpServerId,
            })

            inputUidSuccess(this.gameName)

            // 成功失焦、不弹起键盘
            this.$refs['zid-input'].blur()
            this.$refs['uid-input'].blur()
          } else {
            const { customTips } = result || {}
            this.errorCode = result.errorCode
            this['detail/setUidValidator']({
              errorCode: this.errorCode,
              customTips,
            })
            this.handleCheck({ isError: true, isZidError: true })
            this['detail/setNickName']('')
            this['detail/setUserId']('')
            this['detail/setCheckServerItem']({})

            inputUidFail(this.gameName, this.errorCode)
            if (this.isEventSelect) {
              clearTimeout(timer)
              timer = setTimeout(() => {
                this.$refs['uid-input'] && this.$refs['uid-input'].focus()
              }, 300)

              this.isEventSelect = false
            }
          }
        } catch (error) {
          this.handleCheck({ isError: true, isZidError: true })

          this['detail/setNickName']('')
          this['detail/setUserId']('')

          if (this.isEventSelect) {
            clearTimeout(timer)
            timer = setTimeout(() => {
              this.$refs['uid-input'] && this.$refs['uid-input'].focus()
            }, 300)

            this.isEventSelect = false
          }

          window.console.warn(
            '%c[_mlbb_uidAsyncValidator_]方法报错',
            'color:#0f0',
            error
          )
        }
      },
      handleInput() {
        this.uidValue = this.uidValue.replace(/\D/g, '')
        this.zoneId = this.zoneId.replace(/\D/g, '')

        if (this.uidValue.trim() === '' || this.zoneId.trim() === '') {
          if (this.uidValue.trim() === '') {
            this['detail/setUserId']('')
          }
          if (this.zoneId.trim() === '') {
            this['detail/setCheckServerItem']({})
          }
          this['detail/setNickName']('')
          this.handleCheck()
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
